import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useQueryParams } from "../hooks/useQueryParams";
import visitorService from "../services/VisitorService";

const QueryParamsHandler = () => {
  const { getId, getUser } = useQueryParams();
  const location = useLocation();
  const hasProcessedRef = useRef(false);
  
  const id = getId();
  const user = getUser();
  
  useEffect(() => {
    const sendQueryParamsToApi = async () => {
      if (location.pathname === '/unsubscribe') {
        return;
      }
      
      if (id && user && !hasProcessedRef.current) {
        hasProcessedRef.current = true;
        
        try {
          const params: { id?: string; user?: string; pageSource?: string } = {};
          if (id) params.id = id;
          if (user) params.user = user;
          params.pageSource = location.pathname;

          await visitorService.sendVisitor(params as { id: string; user: string; pageSource: string });
        } catch (error) {
          hasProcessedRef.current = false;
        }
      }
    };
    
    sendQueryParamsToApi();
  }, [id, user, location.pathname]);
  
  return null;
};

export default QueryParamsHandler;
